import BaseViewModel from '@src/slide/infrastructure/module/independent/view-service-define/base/base-view-model';
import {
    IPcLeftThumbnailListProps,
    IPcLeftThumbnailListState,
    SECTION_WIDTH,
} from '@src/slide/application/service/pc-left-thumbnail-list/core/type';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { IMasterModel } from '@src/slide/domain/ui-model/element-modeles/Interface/master-model.interface';
import { ISectionModel } from '@src/slide/domain/ui-model/element-modeles/Interface/section-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { EDIT_TYPE } from '@src/slide/domain/selection/constant/edit-type';
import { ILayoutModel } from '@src/slide/domain/ui-model/element-modeles/Interface/layout-model.interface';

export default class PcLeftThumbnailListModel extends BaseViewModel<IPcLeftThumbnailListProps>
    implements IPcLeftThumbnailListState {
    public isPressed: boolean;
    public slideModelList: Array<ISlideModel>;
    public masterModelList: Array<IMasterModel>;
    public layoutModelList: Array<ILayoutModel>;
    public currentSlideType: string;
    public slideClearanceIndex: number;
    public slideHeight: number;
    public slideWidth: number;
    public sectionWidth: number;
    public originalDragSlide: any;
    public slideInnerHeight: number;
    public currentDragIndex: number;
    public historyTipsSlide: number;
    public historyTipsTops;
    public historyTipsScrollTop;
    public lockInfo: any;
    public outside: boolean;
    public originalDragIndex: number;
    public shouldUpdate: boolean;
    public isFirstSlideShow: boolean;
    public isShowingHistory: boolean;
    public currentSlideIndex: number;
    public editType: string;
    public viewType: string;
    public isDraggingSection: boolean;
    public sectionList: ISectionModel[];
    public isSectionDrag: boolean;
    public sectionFoldedState: boolean[];

    public initModel(props?: IPcLeftThumbnailListProps, initObj?: Partial<this>): void {
        const {
            slideWidth = 0,
            slideHeight = 0,
            slideInnerHeight = 0,
            slideModelList = [],
            masterModelList = [],
            layoutModelList = [],
            sectionList = [],
            currentSlideType = UIModelType.SLIDE,
            editType = EDIT_TYPE.SLIDE,
            isFirstSlideShow = false,
            isShowingHistory = false,
            currentSlideIndex = 0,
            slideClearanceIndex = 0,
        } = initObj || { };
        this.slideWidth = slideWidth;
        this.slideHeight = slideHeight;
        this.slideInnerHeight = slideInnerHeight;

        this.sectionWidth = SECTION_WIDTH;
        this.slideModelList = slideModelList;
        this.masterModelList = masterModelList;
        this.layoutModelList = layoutModelList;
        this.sectionList = sectionList;

        this.currentSlideType = currentSlideType;
        this.editType = editType;

        this.isFirstSlideShow = isFirstSlideShow;
        this.isShowingHistory = isShowingHistory;
        this.currentSlideIndex = currentSlideIndex;
        this.slideClearanceIndex = slideClearanceIndex;

        this.isPressed = false;
        this.historyTipsSlide = -1;
        this.historyTipsTops = {};
        this.historyTipsScrollTop = 0;
        this.lockInfo = [];  // lockInfo第一次渲染可以不显示，避免把SlideApp import进来
        this.outside = false;
        this.originalDragIndex = -1;
        this.originalDragSlide = null;
        this.currentDragIndex = -1;
        this.shouldUpdate = false;
        this.isDraggingSection = false;
        this.isSectionDrag = false;
        this.sectionFoldedState = [];
    }
}
